<template>
    <v-card class="grey lighten-4">
        <v-toolbar dense dark color="light-blue darken-4">
            <v-toolbar-title class="my-list-title"><v-icon>mdi-dog</v-icon>&nbsp;Mascota</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="onClose" v-on="on">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row justify="space-between">
                    <v-col cols="12" md="9">
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field
                                        hide-details
                                        class="my-5"
                                        dense
                                        prepend-icon="mdi-calendar"
                                        label="Fecha de registro"
                                        type="text"
                                        v-model="fechaRegistro"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field
                                        hide-details
                                        class="my-5"
                                        dense
                                        prepend-icon="mdi-counter"
                                        label="Usuario"
                                        type="text"
                                        v-model="numeroUsuario"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        hide-details
                                        class="my-5"
                                        dense
                                        prepend-icon="mdi-star"
                                        label="Tipo de membresía"
                                        type="text"
                                        v-model="tipoUsuario"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="tipoUsuario==='Premium'" cols="12" sm="6" md="3">
                                    <v-switch
                                        dense
                                        v-model="activeMembership"
                                        label="Membresía activa"
                                        color="pink accent-3"
                                        @change="changeMembershipStatus"
                                    ></v-switch>
                                </v-col>
                                <!-- <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-earth"
                                        label="País"
                                        type="text"
                                        v-model="pais"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-map-marker"
                                        label="Estado"
                                        type="text"
                                        v-model="estado"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col> -->
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-dog-side"
                                        label="Especie"
                                        type="text"
                                        v-model="especie"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-dog"
                                        label="Raza"
                                        type="text"
                                        v-model="raza"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-palette"
                                        label="Color"
                                        type="text"
                                        v-model="color"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-gender-male-female"
                                        label="Sexo"
                                        type="text"
                                        v-model="sexo"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="3">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-calendar-plus"
                                        label="Fecha de nacimiento"
                                        type="text"
                                        v-model="fechaNacimiento"
                                        readonly
                                        color="light-blue darken-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="3">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-cake-variant"
                                        label="Edad"
                                        type="text"
                                        v-model="edad"
                                        readonly
                                        color="light-blue darken-4"
                                        :suffix="edad < 2 ? 'año' : 'años'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="3">
                                    <v-text-field
                                        dense
                                        prepend-icon="mdi-weight"
                                        label="Peso"
                                        type="text"
                                        v-model="peso"
                                        readonly
                                        color="light-blue darken-4"
                                        suffix="kg"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col v-if="tipoUsuario==='Premium'" cols="12" md="3" align-self="center">
                        <v-card
                            ref="qr_card"
                            hover
                            height="auto"
                            width="200"
                            class="center_img"
                        >
                            <qrcode-vue
                                v-if="qrValue!=''"
                                :value="qrValue"
                                :size="qrSize"
                                level="H"
                            ></qrcode-vue>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="tipoUsuario==='Premium'">
                    <v-col cols="10">
                        <v-text-field
                            dense
                            label="Cadena"
                            outlined
                            v-model="qrValue"
                            readonly
                            ref="myQRcode" 
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn small fab color="light-blue darken-1" @click="onCopyQR" v-on="on">
                                    <v-icon color="white">mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                            <span>Copiar cadena</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row align="start" no-gutters>
                    <v-col class="body-2 font-weight-bold light-blue--text text--darken-4">
                        &nbsp;Dirección
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-divider class="light-blue darken-4"></v-divider>
                    <br>
                </v-row>
                <v-row v-if="tipoUsuario==='Premium'" no-gutters justify="space-between">
                    <v-col cols="12" sm="6" md="5">
                        <v-text-field
                            dense
                            label="Calle"
                            type="text"
                            v-model="direccion.calle"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            dense
                            label="Colonia"
                            type="text"
                            v-model="direccion.colonia"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            dense
                            label="Código postal"
                            type="text"
                            v-model="direccion.cp"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="tipoUsuario==='Premium'" no-gutters justify="space-between">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            dense
                            label="Ciudad"
                            type="text"
                            v-model="direccion.ciudad"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            dense
                            label="Estado"
                            type="text"
                            v-model="direccion.estado"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            dense
                            label="País"
                            type="text"
                            v-model="direccion.pais"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-else no-gutters>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            dense
                            label="Estado"
                            type="text"
                            v-model="direccion.estado"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            dense
                            label="País"
                            type="text"
                            v-model="direccion.pais"
                            readonly
                            color="light-blue darken-4"
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <v-row>
                    <v-col cols="12">
                        <v-tabs background-color="light-blue darken-1" dark show-arrows>
                            <v-tab class="text-none"><v-icon>mdi-needle</v-icon> &nbsp; Vacunación</v-tab>
                            <v-tab class="text-none"><v-icon>mdi-bacteria</v-icon> &nbsp; Desparasitación</v-tab>
                            <v-tab class="text-none"><v-icon>mdi-toothbrush</v-icon> &nbsp; Limpieza dental</v-tab>
                            <v-tab class="text-none"><v-icon>mdi-apple-keyboard-command</v-icon> &nbsp; Otros</v-tab>

                            <!--*********** Tab Vacunación: ****************************************************-->
                            <v-tab-item>
                                <v-card class="mx-auto" height="300">
                                    <v-toolbar height="30" flat color="light-blue lighten-4">
                                        <v-toolbar-title class="body-2 black--text font-weight-bold">Historial de vacunación</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn text :disabled="selectedVax.length === 0" @click="onVax" v-on="on">
                                                    <v-icon>mdi-magnify</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Ver</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-data-table
                                        fixed-header
                                        :headers="vaxTableHeader"
                                        :items="petVaxes"
                                        v-model="selectedVax"
                                        item-key="vacunaid"
                                        locale="es-MX"
                                        hide-default-footer
                                        no-data-text=""
                                        :show-select="true"
                                        single-select
                                        dense
                                        :items-per-page="petVaxes.length"
                                        height="270"
                                    ></v-data-table>
                                </v-card>
                            </v-tab-item>

                            <!--*********** Tab Desparasitación: ****************************************************-->
                            <v-tab-item>
                                <v-card class="mx-auto" height="300">
                                    <v-toolbar height="30" flat color="light-blue lighten-4">
                                        <v-toolbar-title class="body-2 black--text font-weight-bold">Historial de desparasitación</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn text :disabled="selectedDesp.length === 0" @click="onDesp" v-on="on">
                                                    <v-icon>mdi-magnify</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Ver</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-data-table
                                        fixed-header
                                        :headers="despTableHeader"
                                        :items="petDewormings"
                                        v-model="selectedDesp"
                                        item-key="desparasitacionid"
                                        locale="es-MX"
                                        hide-default-footer
                                        no-data-text=""
                                        :show-select="true"
                                        single-select
                                        dense
                                        :items-per-page="petDewormings.length"
                                        height="270"
                                    ></v-data-table>
                                </v-card>
                            </v-tab-item>

                            <!--*********** Tab Limpieza Dental: ****************************************************-->
                            <v-tab-item>
                                <v-card class="mx-auto" height="300">
                                    <v-toolbar height="30" flat color="light-blue lighten-4">
                                        <v-toolbar-title class="body-2 black--text font-weight-bold">Historial de limpiezas dentales</v-toolbar-title>
                                    </v-toolbar>
                                    <v-data-table
                                        fixed-header
                                        :headers="dentalCleaningTableHeader"
                                        :items="petDentalCleanings"
                                        item-key="limpiezaid"
                                        locale="es-MX"
                                        hide-default-footer
                                        no-data-text=""
                                        :show-select="false"
                                        dense
                                        :items-per-page="petDentalCleanings.length"
                                        height="270"
                                    ></v-data-table>
                                </v-card>
                            </v-tab-item>

                            <!--*********** Tab Otros: ****************************************************-->
                            <v-tab-item>
                                <v-card class="mx-auto" height="300">
                                    <v-toolbar height="30" flat color="light-blue lighten-4">
                                        <v-toolbar-title class="body-2 black--text font-weight-bold">Historial de otros procedimientos</v-toolbar-title>
                                    </v-toolbar>
                                    <v-data-table
                                        fixed-header
                                        :headers="otherProceduresTableHeader"
                                        :items="petOtherProcedures"
                                        item-key="procedimientoid"
                                        locale="es-MX"
                                        hide-default-footer
                                        no-data-text=""
                                        :show-select="false"
                                        dense
                                        :items-per-page="petOtherProcedures.length"
                                        height="270"
                                    ></v-data-table>
                                </v-card>
                            </v-tab-item>

                        </v-tabs>
                    </v-col>
                </v-row>

                <!-- Modal para ver una vacuna: ********************************-->
                <v-row v-if="showVaxDlg">
                    <v-dialog v-model="showVaxDlg" persistent :width=vaxDlgWidth>
                        <vacuna
                            :vacunaid = selectedVax[0].vacunaid
                            :mascotaid = selectedVax[0].mascotaid
                            :fileName = selectedVax[0].filename
                            :fileType = selectedVax[0].filetype
                            :fileDownloadUri = selectedVax[0].filedownloaduri
                            :vacuna = selectedVax[0].vacuna
                            :fechaAplicacion = selectedVax[0].aplicacion
                            :fechaExpiracion = selectedVax[0].expiracion
                            :marca = selectedVax[0].marca
                            :lote = selectedVax[0].lote
                            :registro = selectedVax[0].registro
                            >
                        </vacuna>
                    </v-dialog>
                </v-row>
                <!-- Termina modal para ver una vacuna ********************************-->

                <!-- Modal para ver una desparasitación: ********************************-->
                <v-row v-if="showDespDlg">
                    <v-dialog v-model="showDespDlg" persistent :width="despDlgWidth">
                        <desparasitacion
                            :desparasitacionid = selectedDesp[0].desparasitacionid
                            :mascotaid = selectedDesp[0].mascotaid
                            :fileName = selectedDesp[0].filename
                            :fileType = selectedDesp[0].filetype
                            :fileDownloadUri = selectedDesp[0].filedownloaduri
                            :medicamento = selectedDesp[0].medicamento
                            :fechaAplicacion = selectedDesp[0].aplicacion
                            :fechaExpiracion = selectedDesp[0].expiracion
                            :marca = selectedDesp[0].marca
                            :lote = selectedDesp[0].lote
                            :registro = selectedDesp[0].registro
                            >
                        </desparasitacion>
                    </v-dialog>
                </v-row>
                <!-- Termina modal para ver una desparasitación ********************************-->

                <!-- Modal para confirmar cambio de status de membresía: **************************************** -->
                <v-layout row justify-center>
                    <v-dialog v-model="bDlgChangeMembershipStatus" persistent width="35%">
                        <v-card class="grey lighten-4">
                            <v-toolbar dense color="light-blue darken-4" dark flat>
                                <v-toolbar-title class="my-list-title">Cambiar status de membresía</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon>mdi-wallet-membership</v-icon>
                            </v-toolbar>
                            <v-card-title class="text-center">
                                <div style="margin: auto">
                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                </div>
                                &nbsp; {{ changeStatusTitle }}
                            </v-card-title>
                                    
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="teal darken-3"
                                    class="text-none"
                                    text
                                    @click="onConfirmChangeMemberShipStatus"
                                >OK</v-btn>
                                <v-btn
                                    color="pink darken-1"
                                    class="text-none"
                                    text
                                    @click="onCancelChangeMemberShipStatus"
                                >Cancelar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>
                <!-- Termina Modal para confirmar cambio de status de membresía *************************** -->

            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Vacuna from '@/components/Vacuna';
import Desparasitacion from './Desparasitacion.vue';
import QrcodeVue from 'qrcode.vue'

export default {
    name: 'mascota',
    data() {
        return {
            bMounted: false, //Para saber si ya se puede obtener las dimensiones de los componentes.
            selectedVax: [],
            selectedDesp: [],
            //selectedDentalCleaning: [],
            //selectedOtherProcedures: [],
            vaxTableHeader: [
                /*{
                    text: 'Archivo',
                    sortable: true,
                    align: 'left',
                    value: 'archivo'
                },*/
                {
                    text: 'Vacuna',
                    sortable: true,
                    align: 'left',
                    value: 'vacuna'
                },
                {
                    text: 'Aplicación',
                    sortable: true,
                    align: 'left',
                    value: 'aplicacion'
                },
                {
                    text: 'Expiración',
                    sortable: true,
                    align: 'left',
                    value: 'expiracion'
                },
                {
                    text: 'Marca',
                    sortable: true,
                    align: 'left',
                    value: 'marca'
                },
                {
                    text: 'Lote',
                    sortable: true,
                    align: 'left',
                    value: 'lote'
                }
            ],

            despTableHeader: [
                /*{
                    text: 'Fecha',
                    sortable: true,
                    align: 'left',
                    value: 'fechaRegistro'
                },*/
                {
                    text: 'Medicamento',
                    sortable: true,
                    align: 'left',
                    value: 'medicamento'
                },
                {
                    text: 'Aplicación',
                    sortable: true,
                    align: 'left',
                    value: 'aplicacion'
                },
                {
                    text: 'Expiración',
                    sortable: true,
                    align: 'left',
                    value: 'expiracion'
                },
                {
                    text: 'Marca',
                    sortable: true,
                    align: 'left',
                    value: 'marca'
                },
                {
                    text: 'Lote',
                    sortable: true,
                    align: 'left',
                    value: 'lote'
                }
            ],

            dentalCleaningTableHeader: [
                {
                    text: 'Fecha',
                    sortable: true,
                    align: 'left',
                    value: 'fecha'
                },
                {
                    text: 'Notas',
                    sortable: false,
                    align: 'left',
                    value: 'notas'
                }
            ],

            otherProceduresTableHeader: [
                {
                    text: 'Fecha',
                    sortable: true,
                    align: 'center',
                    value: 'fecha',
                    width: '20%'
                },
                {
                    text: 'Tipo',
                    sortable: false,
                    align: 'left',
                    value: 'tipo',
                    width: '20%'
                },
                {
                    text: 'Notas',
                    sortable: false,
                    align: 'left',
                    value: 'notas',
                    width: '60%'
                }
            ],

            fechaRegistro: '',
            numeroUsuario: 0,
            tipoUsuario: '',
            activeMembership: false,
            direccion: {
                calle: '',
                ciudad: '',
                colonia: '',
                cp: '',
                estado: '',
                pais: '',
            },
            pais: '',
            estado: '',
            especie: '',
            raza: '',
            color: '',
            sexo: '',
            fechaNacimiento: '',
            edad: '',
            peso: '',

            qrValue: '',

            bDlgChangeMembershipStatus: false,
            changeStatusTitle: "",
        }
    },

    created() {
        this.fechaRegistro = this.pet.registro;
        this.numeroUsuario = this.pet.usuarioid;
        this.tipoUsuario = this.pet.tipousuario;
        this.activeMembership = this.pet.membresiaActiva;
        this.direccion = this.pet.direccion;
        this.pais = this.pet.pais;
        this.estado = this.pet.estado;
        this.especie = this.pet.especie;
        this.raza = this.pet.raza;
        this.color = this.pet.color;
        this.sexo = this.pet.sexo;
        this.fechaNacimiento = this.pet.fecha;
        this.edad = this.pet.edad;
        this.peso = this.pet.peso;
        if (this.tipoUsuario === "Premium")
        {
            this.qrValue = "http://petbrief.gtsf.com.mx/qrcode/" + this.pet.token; //Tepmoralmente en subdominio de GTSF.
            console.log("qrValue = ", this.qrValue);
        }
        else
        {
            this.qrValue = "";
        }

    },

    mounted() {
        this.bMounted = true;
    },

    methods:{
        onClose(){
            this.showPetDlg = false;
            this.petID = 0;
        },
        onCopyQR(){
            /*this.$refs.myQRcode.focus();
            document.execCommand("copy");*/
            try {
                navigator.clipboard.writeText(this.qrValue);
            }
            catch(e)
            {
                throw e;
            }
        },
        onVax(){
            console.log("selectedVax = ", this.selectedVax[0]);
            this.showVaxDlg = true;
        },
        onDesp(){
            console.log("selectedDesp = ", this.selectedDesp[0]);
            this.showDespDlg = true;
        },
        onDentalCleaning(){},
        onOtherProcedures(){},

        changeMembershipStatus(){
            console.log("changeMembershipStatus, activeMembership = ", this.activeMembership);
            if (this.activeMembership)
            {
                this.changeStatusTitle = "¿Desea activar la membresía?";
            }
            else
            {
                this.changeStatusTitle = "¿Desea desactivar la membresía?"
            }
            console.log("changeStatusTitle = ", this.changeStatusTitle);
            this.bDlgChangeMembershipStatus = true;
        },

        onConfirmChangeMemberShipStatus()
        {
            this.bDlgChangeMembershipStatus = false;
            var membership = 0;
            if (this.activeMembership)
            {
                membership = 1;
            }
            const membershipInfo = {
                userID: this.pet.usuarioid,
                active: membership,
            }
            this.$store.dispatch('changeMemberShipStatus', membershipInfo);
        },

        onCancelChangeMemberShipStatus()
        {
            this.bDlgChangeMembershipStatus = false;
            this.activeMembership = !this.activeMembership;
        },
    },

    components:
    {
        Vacuna,
        Desparasitacion,
        QrcodeVue,
    },

    computed:{
        ...mapGetters([
            'waitCursor'
        ]),

        showPetDlg: {
            get() {
                return this.$store.getters.showPetDlg;
            },
            set(showPetDlg) {
                this.$store.dispatch('updateShowPetDlg', showPetDlg
                );
            }
        },

        showVaxDlg: {
            get() {
                return this.$store.getters.showVaxDlg;
            },
            set(showVaxDlg) {
                this.$store.dispatch('updateShowVaxDlg', showVaxDlg
                );
            }
        },

        showDespDlg: {
            get() {
                return this.$store.getters.showDespDlg;
            },
            set(showDespDlg) {
                this.$store.dispatch('updateShowDespDlg', showDespDlg);
            }
        },
        
        vaxDlgWidth: {
            get() {
                return this.$store.getters.vaxDlgWidth;
            },
            set(vaxDlgWidth) {
                this.$store.dispatch('updateVaxDlgWidth', vaxDlgWidth);
            }
        },

        despDlgWidth: {
            get() {
                return this.$store.getters.despDlgWidth;
            },
            set(vaxDlgWidth) {
                this.$store.dispatch('updateDespDlgWidth', despDlgWidth);
            }
        },

        petID: {
            get() {
                return this.$store.getters.petID;
            },
            set(petID) {
                this.$store.dispatch('updatePetID', petID);
            }
        },

        pet: {
            get() {
                return this.$store.getters.pet;
            },
            set(pet)
            {
                this.$store.dispatch('updatePet', pet);
            }
        },

        petVaxes: {
            get() {
                return this.$store.getters.petVaxes;
            },
            set(petVaxes)
            {
                this.$store.dispatch('updatePetVaxes', petVaxes);
            }
        },

        petDewormings: {
            get() {
                return this.$store.getters.petDewormings;
            },
            set(petDewormings)
            {
                this.$store.dispatch('updatePetDewormings', petDewormings);
            }
        },

        petDentalCleanings: {
            get() {
                return this.$store.getters.petDentalCleanings;
            },
            set(petDentalCleanings)
            {
                this.$store.dispatch('updatePetDentalCleanings', petDentalCleanings);
            }
        },

        petOtherProcedures: {
            get() {
                return this.$store.getters.petOtherProcedures;
            },
            set(petOtherProcedures)
            {
                this.$store.dispatch('updatePetOterProcedures', petOtherProcedures);
            }
        },

        qrSize() {
            var size;
            /*if (this.bMounted)
            {
                if (this.$refs.qr_card.$el.clientWidth < this.$refs.qr_card.$el.clientHeight)
                {
                    size = this.$refs.qr_card.$el.clientWidth;
                }
                else
                {
                    size = this.$refs.qr_card.$el.clientWidth;
                }
            }
            else*/
            {
                size = '200';
            }

            console.log("size = " + size);
           
            return size;
        },
    },

    
}
</script>

<style scoped>
.center_img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

</style>
